(function() {
  'use strict';

  angular
  .module('irricrops')
  .factory('temporadaFac', ['urls', '$http', '$mdDialog',
    function(urls, $http, $mdDialog) {

      var temporadas              = null;
      var temporadaActiva         = null;
      var temporadaAnteriorActiva = null;
      var prom                    = null;
      var colorsTemporada         = {};

      var colors = [
        "#9C27B0",
        "#03A9F4",
        "#8BC34A",
        "#fbc02d",
        "#3F51B5",
        "#673AB7",
        "#009688",
        "#FF9800",
        "#4CAF50",
        "#0097a7",
        "#6d4c41"
      ];


      var dateToTemporada = function(date){
        var r = null;
        _.each(temporadas, function(t){
          var mi = moment(t.inicio);
          var mf = moment(t.fin).endOf('day');
          var m = moment(date);
          if(m.isBetween(mi, mf, "()")){
            r = t;
          }
        })
        return r;
      }

      var getActualTemporada = function(){
        var d = new Date();
        var r = dateToTemporada();
        return r;
      }

      var reloadPromTemporadas = function(datahttp){
        var d = {};
        if(datahttp !== undefined){
          d.params = datahttp;
        }
        prom = $http.get(urls.BASE + "/temporadas", d)
          .then(
          function(data) {
            // GET temporadas
            temporadas = data.data.data;
            var temporadaAnterior = null;
            _.each(temporadas, function(temporada, index) {
              temporada.inicio_date = moment(temporada.inicio).toDate();
              temporada.fin_date    = moment(temporada.fin).toDate();
              if (temporada.activo) {
                temporadaActiva         = temporada;
                temporadaAnteriorActiva = temporadaAnterior;
              }
              temporada.color                    = colors[index];
              colorsTemporada[temporada.periodo] = colors[index];
              temporadaAnterior                  = temporada;
            });
            if (temporadaActiva === null) {
              console.error("No hay temporada Activa");
            }
            return data;

          }, function(ev) {
            console.error("Error en obtener temporadas");
          });
        return prom;
      }


      var getColorPeriodo = function (periodo) {
        var defColor = "##FF0000";
        return colorsTemporada[periodo] || defColor;
      }

      var dialogTemporadaCtrl = ['$scope', function($scope){
        var vm = this;
        vm.download= function(temporada){
          $mdDialog.hide(temporada);
        }
        vm.cancel= function(){
          $mdDialog.cancel();
        }
      }];

      var  dialogSelectTemporada = function(event){
        var p = $mdDialog.show({
          controller          : dialogTemporadaCtrl,
          controllerAs        : 'd',
          templateUrl         : 'components/vinedo/newtimeline/popover/dialogTemporada.tmpl.html',
          parent              : angular.element(document.body),
          targetEvent         : event,
          clickOutsideToClose : true,
          bindToController    : true,
          locals              : {
            temporadas: temporadas
          }
        });
        p.then(function(temporada) {
          console.log(temporada.periodo);
        }, function() {
        });
        return p;
      }

      return {
        dateToTemporada: dateToTemporada,
        getActualTemporada : getActualTemporada,
        getTemporadas: function(reload, datahttp) {
          if(reload || prom == null){
            return reloadPromTemporadas(datahttp);
          }
          return prom;
        },
        cleanTemporadas : function(){
          prom = null;
        },
        getActiva : function() {
          return temporadaActiva;
        },
        getAnteriorActiva: function() {
          return temporadaAnteriorActiva;
        },
        getColorPeriodo : getColorPeriodo,
        dialogSelectTemporada : dialogSelectTemporada,

        getAnterior : function(temporadaBuscar) {
          var temporadaAnterior = null;
          var temporadaAnteriorBuscada = null;
          angular.forEach(temporadas, function(temporada) {
            if(temporadaBuscar.periodo == temporada.periodo){
              temporadaAnteriorBuscada = temporadaAnterior;
            }
            temporadaAnterior = temporada;
          });
          return temporadaAnteriorBuscada;
        },

        getByPeriodo : function(periodo) {
          var temporadaBuscada = null;
          angular.forEach(temporadas, function(temporada) {
            if(periodo == temporada.periodo){
              temporadaBuscada = temporada;
            }
          });
          return temporadaBuscada;
        }

      };
    }]);
  })();
